/* 🤖 this file was generated by svg-to-ts */
export const iconZksyncera: {
  name: 'zksyncera';
  data: string;
} = {
  name: 'zksyncera',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="zksyncera__Layer_1" width="32" height="32" x="0" y="0" version="1.1" viewBox="0 0 400 400"><circle cx="200" cy="200" r="200" fill="#fff" fill-rule="evenodd" clip-rule="evenodd"/><path d="m316 199-66.7-66.4v48.6l-66.2 48.7h66.2v35.5zm-235 0 66.7 66.4v-48.3l66.2-49.1h-66.2v-35.5z" style="fill-rule:evenodd;clip-rule:evenodd"/></svg>`,
};
